//
//
//
//
//
//
//

export default {
  props: {
    count: {
      type: Number,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
}
